import { COURSE_ICONS } from '..'

export const getIconFromString = (iconString: string) => {
  return COURSE_ICONS.find((icon) => icon.name === iconString)?.icon
}
